import React from "react";
import ProgressIndicator from "../components/common/ProgressIndicator";
import Card from "../components/common/Card";
import Pagination from "../components/mobile/Pagination";

import { GameContext } from "../context/GameContext";

const GameMobileView = () => {
  const { isFlipped, currentQuestion, questionsArray } =
    React.useContext(GameContext);
  return (
    <div className="game-mobile_view">
      <ProgressIndicator />
      <Card />
      {!isFlipped || currentQuestion === questionsArray.length - 1 ? (
        <Pagination />
      ) : null}
    </div>
  );
};

export default GameMobileView;
